<p-card   [ngStyle]="{
    display: isMobile() ? 'block' : 'inline-block',
    width: isMobile() ? '350px' : '450px'
  }"
styleClass="p-card-shadow">
    <ng-template pTemplate="header">
        <div class="row">
            <p-avatar image="{{customer.profileImage}}" styleClass="mr-2" size="xlarge" shape="circle">
            </p-avatar>
            <div class="column" style="width: 100%;  margin-inline-start: 10px;">
                <span class="name">
                    {{customer.name}}
                </span>
                <span class="job">
                    {{customer.job}}
                </span>
            </div>
        </div>


    </ng-template>
    <div class="card-text">   <p>{{customer.text}}</p></div>
    <ng-template pTemplate="footer">
        <div *ngIf="customer.video" class="border_video">
            <video  controls (click)="toggleVideo()" #videoPlayer class="video">
                <source src="{{customer.video}}" type="video/mp4" />
            </video>
            <img *ngIf="!isPlay" class="playImage" src="assets/images/play-icon.svg" (click)="toggleVideo()">
        </div>
    </ng-template>
</p-card>